/**
 * Entry points for MESSENGER_OPENED event.
 */
export enum MessengerEntryPoint {
  DEAL_HEADER = 'DealHeader',
  DOCUMENT_TITLE = 'DocumentTitle',
  FOOTER = 'Footer',
  HEADER_SUBSCRIPTIONS = 'HeaderSubscriptions',
  HEADER_TASKS = 'HeaderTasks',
  LINK = 'Link',
  PART_TITLE = 'PartTitle',
  SIDEBAR = 'Sidebar',
  RFQ_PROCESS = 'RfqProcess',
  /** workspaces entry points */
  WORKSPACES_DEAL = 'WorkspacesDeal',
  WORKSPACES_ENQUIRY = 'WorkspacesEnquiry',
  WORKSPACES_ORDER_CONFIRMATION = 'WorkspacesOrderConfirmation',
  WORKSPACES_QUALITY_CONTROL = 'WorkspacesQualityControl',
  WORKSPACES_PROVIDER_ORDER = 'WorkspacesProviderOrder',
  WORKSPACES_CLAIM = 'WorkspacesClaim',
  WORKSPACES_SHIPPING = 'WorkspacesShipping',
  WORKSPACES_STORAGE = 'WorkspacesStorage',
  WORKSPACES_BILLING_ACCOUNT = 'WorkspacesBillingAccount',
  WORKSPACES_RFQ = 'WorkspacesRfq',
  WORKSPACES_RFQ_OFFER = 'WorkspacesRfqOffer',
  WORKSPACES_CUSTOMER = 'WorkspacesCustomer',
  WORKSPACES_MESSAGES = 'WorkspacesMessages',
  WORKSPACES_MESSAGE_SUBSCRIPTIONS = 'WorkspacesMessageSubscriptions',
}

/**
 * Places for SUBSCRIBED event.
 */
export enum SubscribePlace {
  SIDEBAR = 'Sidebar',
}

/**
 * Keys for amplitude event attributes
 */
export enum AmplitudeAttributeKey {
  ENTRY_POINT = 'EntryPoint',
  PLACE = 'Place',
  SIDE = 'Side',
}

export enum AmplitudeMessengerEvent {
  MESSENGER_OPENED = 'MessengerOpened',
  MESSENGER_CLOSED = 'MessengerClosed',
  MESSENGER_SIDE_SWAPPED = 'MessengerSideSwapped',
  SUBSCRIBE = 'Subscribe',
  UNSUBSCRIBE = 'Unsubscribe',
  AI_WRITER_TRANSLATE = 'AiWriterTranslate',
  AI_WRITER_PROOFREAD = 'AiWriterProofread',
  AI_WRITER_APPLY = 'AiWriterApply',
  AI_WRITER_RESET_IMPROVED = 'AiWriterResetImproved',
}

export enum AmplitudeErpDealEvent {
  SORT_SIDEBAR_DEAL_OBJECTS = 'SortSidebarDealObjects',
  DEAL_LEFT_HEADER_ACTION = 'DealLeftHeaderAction',
  DEAL_LEFT_SIDEBAR_LAYOUT = 'DealLeftSidebarLayout',
}

export const SEND_EMAIL_BUTTON_CLICK_EVENT = 'SendEmailButtonClick';

export enum AmplitudeErpObjectsFilterEvent {
  FILTER_PRESET_SELECT = 'ErpObjectsFilterPresetSelect',
  FILTER_OBJECT_CHANGE = 'ErpObjectsFilterObjectChang',
  FILTER_RESET = 'ErpObjectsFilterReset',
  FILTER_APPLY = 'ErpObjectsFilterApply',
}

export enum AmplitudeRiskTagsEvent {
  RISK_TAGS_CLOSED = 'ErpRiskTagsClosedEvent',
}
